import * as R from 'ramda'
import {
  BaseExtraServiceEquipmentPrice,
  BaseExtraService,
  BaseExtraServiceAnswer,
  EquipmentType,
  ExtraServiceEquipmentPrice,
  ExtraService,
  ExtraCommercialTermEquipmentPrice,
  ExtraCommercialTerm
} from '../../types/types'
import { round } from '../common/prices'

export function inflateFlatExtraServicePrices(prices: ExtraServiceEquipmentPrice[]): ExtraService[] {
  return inflateFlatPrices(prices) as ExtraService[]
}

export function inflateFlatExtraCommercialTermPrices(
  prices: ExtraCommercialTermEquipmentPrice[]
): ExtraCommercialTerm[] {
  return inflateFlatPrices(prices) as ExtraCommercialTerm[]
}

function inflateFlatPrices(prices: BaseExtraServiceEquipmentPrice[]): BaseExtraService[] {
  const answers = R.toPairs(R.groupBy(v => v.key + '-' + v.answer, prices)).map(
    ([_, value]): BaseExtraServiceAnswer => ({
      key: value![0].key,
      answer: value![0].answer,
      totalPrice: round(value!.reduce((total, current) => total + current.servicePrice, 0)),
      equipmentPrices: value!
    })
  )
  return R.toPairs(R.groupBy(v => v.key, answers))
    .map(
      ([key, value]): BaseExtraService => ({
        key,
        answers: value!
      })
    )
    .sort((a, b) => a.key.localeCompare(b.key))
}

interface NameContainer {
  inventoryNumber?: string | null
  inventory_number?: string | null
  description?: string | null
  koneEquipmentNumber?: string | null
  kone_equipment_number?: string | null
  equipmentType?: EquipmentType | null
  equipment_type?: string | null
}

// Internal data structures use camelCase and database uses snake_case
export function getEquipmentName(nameContainer: NameContainer) {
  return (
    nameContainer.inventoryNumber ||
    nameContainer.inventory_number ||
    nameContainer.description ||
    nameContainer.koneEquipmentNumber ||
    nameContainer.kone_equipment_number ||
    nameContainer.equipmentType ||
    nameContainer.equipment_type ||
    'unknown'
  )
}
